export type AccessLevel = "NONE" | "READ" | "MODIFY" | "CREATE" | "DELETE";

export const AccessRank: Record<AccessLevel, number> = {
  NONE: 0,
  READ: 1,
  MODIFY: 2,
  CREATE: 3,
  DELETE: 4,
};

export interface PrivilegeMap {
  [module: string]: AccessLevel;
}

export const parsePermissions = (permissions: string[]): PrivilegeMap => {
  const result: PrivilegeMap = {};

  for (const perm of permissions) {
    const [code, module] = perm.split(":");

    let level: AccessLevel = "NONE";
    switch (code) {
      case "R":
        level = "READ";
        break;
      case "C":
        level = "CREATE";
        break;
      case "D":
        level = "DELETE";
        break;
    }

    if (!result[module] || AccessRank[level] > AccessRank[result[module]]) {
      result[module] = level;
    }
  }

  return result;
};

export const hasAccess = (
  module: string,
  required: AccessLevel,
  privileges: PrivilegeMap,
  hasActivePlan: boolean
): boolean => {
  const userLevel = privileges[module] || "NONE";
  const levelToCheck = hasActivePlan ? userLevel : "READ";
  return AccessRank[levelToCheck] >= AccessRank[required];
};

export const privilegeTypes: PrivilegeMap = {
  R: "READ",
  C: "CREATE",
  D: "DELETE",
  M: "MODIFY",
  N: "NONE",
};

export const featureObject = {
  COMPANY: "COMPANY",
  COM_PREF: "COM_PREF",
  REBRAND: "REBRAND",
  SUBSCRIPTION: "SUBSCRIPTION",
  BRANCH: "BRANCH",
  USERS: "USERS",
  USR_ROLE: "USR_ROLE",
  USR_ROLE_ASGN: "USR_ROLE_ASGN",
  COUNTRY: "COUNTRY",
  SUBS_USG: "SUBS_USG",
};
